import LocalizationService from "services/localizationService";
import { computed, reaction } from "mobx";
import { bound } from "@frui.ts/helpers";
import ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { interfaces } from "inversify";
import { getValidationMessage } from "@frui.ts/validation";
import { CSTermsAgreementDocumentPath, DETermsAgreementDocumentPath, ENTermsAgreementDocumentPath } from "../../../../config";
import ChargeOrder from "models/chargeOrder";
import ChargeOrderService from "services/chargeOrderService";

export default class TermsAgreementViewModel extends ScreenBase {
  private documentPathRegex = /%documentPath%/g;
  private unsubscriptions: Array<() => void> = [];

  constructor(
    public chargeOrder: ChargeOrder,
    private chargeOrderService: ChargeOrderService,
    private localizationService: LocalizationService
  ) {
    super();
  }

  protected onInitialize(): Promise<any> | void {
    this.chargeOrder._termsAgreement = false;
    this.unsubscriptions.push(reaction(() => this.chargeOrder._termsAgreement, this.onAgreementChanged));
    return super.onInitialize();
  }

  protected onDeactivate(isClosing: boolean): Promise<any> | void {
    if (isClosing) {
      this.unsubscriptions.forEach((unsubscribe) => unsubscribe());
      this.unsubscriptions = [];
    }
    return super.onDeactivate(isClosing);
  }

  @bound
  onAgreementChanged() {
    this.chargeOrderService.persistChargeOrder();
  }

  @bound
  translateGeneral(code: string) {
    return this.localizationService.translateGeneral(`eshop.order.summary.${code}`);
  }

  @bound
  translateAttribute(code: string) {
    return this.localizationService.translateAttribute("payment", code);
  }

  @computed get termAgreementError() {
    return getValidationMessage(this.chargeOrder, "_termsAgreement");
  }

  @computed
  get translateTermsAgreement() {
    return this.translateAttribute("termsAgreement").replace(this.documentPathRegex, this.termsAgreementDocumentPath);
  }

  @computed
  private get termsAgreementDocumentPath() {
    switch (this.localizationService.locale) {
      case "cs":
        return CSTermsAgreementDocumentPath;
      case "de":
        return DETermsAgreementDocumentPath;
      default:
        return ENTermsAgreementDocumentPath;
    }
  }

  static Factory({ container }: interfaces.Context) {
    return (chargeOrder: ChargeOrder) => {
      return new TermsAgreementViewModel(chargeOrder, container.get(ChargeOrderService), container.get(LocalizationService));
    };
  }
}
